/** Get company */
export const GET_COMPANY_SUCCESS = "GET_COMPANY_SUCCESS"
export const GET_COMPANY_ERROR = "GET_COMPANY_ERROR"

/** Update Company detail */
export const UPDATE_COMPANY_SUCCESS = 'UPDATE_COMPANY_SUCCESS'
export const UPDATE_COMPANY_ERROR = 'UPDATE_COMPANY_ERROR'